import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import components from './helpers/components'
import { appSettings } from '@/environment'

// third party pluggins
import VueGtag from 'vue-gtag'
import VueMeta from 'vue-meta'

Vue.config.productionTip = true

Vue.use(components)
Vue.use(VueMeta)
Vue.use(VueGtag, {
  config: { id: "G-KE7ZF4X1K7" }
})

Vue.directive('autofocus', function(el, { value }) {
    if (value) {
        el.focus()
    }

    // console.group('Vue.directive(autofocus)')
    // console.log(el, value)
    // console.groupEnd()
})


Vue.prototype.$appSettings = appSettings

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')
